import { isReviewAccessEnabled } from '../utils/environment'
import { AppError } from '../utils/errors'

type AppIdentity = {
  email?: string | null
  isAnonymous?: boolean
}

type AccessOptions = {
  reviewAccess?: boolean
  ownerEmail?: string
}

const DEFAULT_OWNER_EMAIL = 'superman50196@gmail.com'

const normalizedOwnerEmail = () => (
  import.meta.env.VITE_OWNER_EMAIL?.trim().toLocaleLowerCase() || DEFAULT_OWNER_EMAIL
)

export const hasPrivateAppAccess = (
  identity: AppIdentity,
  options: AccessOptions = {},
): boolean => {
  const reviewAccess = options.reviewAccess ?? isReviewAccessEnabled()
  if (reviewAccess) return true
  if (identity.isAnonymous) return false

  const ownerEmail = (options.ownerEmail ?? normalizedOwnerEmail()).trim().toLocaleLowerCase()
  return Boolean(identity.email && identity.email.trim().toLocaleLowerCase() === ownerEmail)
}

export const requirePrivateAppAccess = (
  identity: AppIdentity,
  options?: AccessOptions,
): void => {
  if (!hasPrivateAppAccess(identity, options)) {
    throw new AppError(
      'Private app access denied.',
      'PRIVATE_APP_ACCESS',
      403,
    )
  }
}

export const appAccessService = {
  hasPrivateAppAccess,
  requirePrivateAppAccess,
  isReviewAccessEnabled,
}
